import GLU from '../glu2.js/src/index';

class ReportApi extends GLU.Api {
  constructor(endpoint) {
    super(endpoint);

    this.createApiActions(
      {
        name: 'getGeosByFipsCodes',
        method: GLU.Api.Post,
        path: '/GetGeoItemsByFipsCodes',
        credentials: true,
      },
      {
        name: 'getSystemReports',
        method: GLU.Api.Get,
        path: '/GetSystemReports',
        credentials: true,
      },
      {
        name: 'getSystemReport',
        method: GLU.Api.Get,
        path: '/GetSystemReport',
        credentials: true,
      },
      {
        name: 'getSystemReportByName',
        method: GLU.Api.Get,
        path: '/GetSystemReportByName',
        credentials: true,
      },
      {
        name: 'getDatasetsOfSurvey',
        method: GLU.Api.Get,
        path: '/GetDatasets?surveyName={surveyName}&includeTables={includeTables}',
        credentials: true,
      },
      {
        name: 'getCpiValues',
        method: GLU.Api.Get,
        path: '/GetConsumerPriceIndices',
        credentials: true,
      },
      {
        name: 'getTablesByGuids',
        method: GLU.Api.Post,
        path: '/GetTablesByGuids',
        credentials: true,
      },
    );
  }
}

export default ReportApi;
